import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ImgUpload.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Popup', {
    attrs: {
      "position": "right",
      "width": "100%",
      "height": "100%",
      "show-mask": false
    },
    model: {
      value: _vm.messageShow,
      callback: function ($$v) {
        _vm.messageShow = $$v;
      },
      expression: "messageShow"
    }
  }, [_c('div', {
    staticClass: "page-ordermessage no-group-border"
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('group', {}, [_c('div', {
    staticClass: "textarea-title"
  }, [_vm._v(i18n.tc("135"))]), _c('x-textarea', {
    attrs: {
      "max": 500,
      "cols": 30,
      "rows": 3,
      "show-counter": true,
      "placeholder": i18n.tc("689"),
      "autosize": true
    },
    on: {
      "on-blur": _vm.checkmessage
    },
    model: {
      value: _vm.messageFields.message,
      callback: function ($$v) {
        _vm.$set(_vm.messageFields, "message", $$v);
      },
      expression: "messageFields.message"
    }
  }), _c('div', {
    staticClass: "line"
  }), _c(__unplugin_components_0, {
    attrs: {
      "hidden-border": "",
      "title": i18n.tc("687")
    },
    on: {
      "on-change": function ($event) {
        _vm.messageFields.imgList = $event;
      }
    },
    model: {
      value: _vm.messageFields.imgList,
      callback: function ($$v) {
        _vm.$set(_vm.messageFields, "imgList", $$v);
      },
      expression: "messageFields.imgList"
    }
  })], 1), _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('div', {
    staticClass: "bottom-btn-body"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    nativeOn: {
      "click": function ($event) {
        _vm.messageShow = false;
      }
    }
  }, [_vm._v(i18n.tc("11"))])], 1), _c('div', {
    staticClass: "bottom-btn-body"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    attrs: {
      "type": "primary",
      "show-loading": _vm.loading
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + i18n.tc("12") + " ")])], 1)])], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };